import { LinkGeneratorApiClient } from "@soluto-private/fes-link-generator-api-client";
import { Partners } from "@trailhead/smart-setup-core";
import { LookupPayloads } from "./types";

const LINK_GENERATOR_API_URL = <string>process.env.REACT_APP_LINK_GENERATOR_BASE_URL;

class LinkGeneratorGateway {
  url: string;

  constructor(url: string){
    this.url = url;
  }

  private _getLinkGeneratorApiClient(){
    return new LinkGeneratorApiClient({
      clientApplicationName: 'trailhead',
      url: this.url,
    });
  }

  public async getLinkData(
    partner: Partners,
    uuid: string,
  ): Promise<LookupPayloads[Partners] | undefined> {
    const client = this._getLinkGeneratorApiClient();
    const data = await client.lookup(uuid);
    if(data.body){
      return data.body as LookupPayloads[typeof partner];
    }

    return undefined;
  }
}

export const linkGeneratorGateway = new LinkGeneratorGateway(LINK_GENERATOR_API_URL);
